import SafeIcon from '../common/SafeIcon';
import { FiArrowLeft, FiShield } from 'react-icons/fi';
import { siteConfig } from '../config/site';

function AppHeader({ showBack, onBack, progress, total }) {
  return (
    <header className="site-header">
      <div className="header-inner">
        <a className="brand-lockup" href="https://www.bpasolutions.au" aria-label="Visit BPA Solutions website">
          <span className="brand-mark">BPA</span>
          <span className="brand-copy">
            <strong>{siteConfig.brand}</strong>
            <small>{siteConfig.tagline}</small>
          </span>
        </a>
        <div className="header-meta">
          {showBack && (
            <button className="back-button" onClick={onBack} type="button">
              <SafeIcon icon={FiArrowLeft} aria-hidden="true" />
              <span>Back</span>
            </button>
          )}
          <div className="privacy-note">
            <SafeIcon icon={FiShield} aria-hidden="true" />
            <span>Private assessment</span>
          </div>
        </div>
      </div>
      {progress !== null && (
        <div className="progress-wrap" aria-label={`Question ${progress} of ${total}`}>
          <div className="progress-track">
            <div className="progress-fill" style={{ width: `${(progress / total) * 100}%` }} />
          </div>
          <span>Question {progress} of {total}</span>
        </div>
      )}
    </header>
  );
}

export default AppHeader;